export const enum VatMode {
  NON_VAT_PAYER = "non-vat-payer",
  IDENTIFIED_PERSON = "identified-person",
  VAT_PAYER = "vat-payer",
}
